export const adaptPrivilegesResponse = (res) =>
  res?.permissions?.map((item) => ({ ...item, id: item.name }));
